<template>
  <div class="flex flex-col w-full relative">
    <div class="rounded-lg bg-WHITE flex flex-row p-3 gap-3 items-center w-full">
      <font-awesome-icon class="black-icon" icon="fa-solid fa-magnifying-glass" />
      <input
        v-model="message"
        placeholder="Search NFT"
        class="placeholder-[##8B8B8B] bg-WHITE border-0 focus:outline-none text-sm text-BLACK w-full"
      />
    </div>

    <div class="relative w-full h-[260px] mt-4">
      <div class="slider-container overflow-x-auto">
        <div class="flex flex-row min-w-max">
          <InheriteNftCard v-for="nft in sliderTempData" :nft-data="nft"> </InheriteNftCard>
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-3 w-full items-start justify-center mt-5">
      <p class="text-sm font-semibold">Trending Collections</p>
      <div
        v-for="collection in collectionTempdata"
        @click="router.push({ name: 'CollectionPage' })"
        class="flex flex-row gap-4 p-3 rounded-md bg-PRIMARY w-full"
      >
        <div
          class="rounded-md p-2 bg-LIGHTGREY w-[60px] h-[50px] flex flex-col justify-center items-center"
        >
          <div class="w-full flex flex-col justify-center items-center">
            <img src="@/assets/images/empty-img.svg" class="w-4 h-5 object-contain" />
          </div>
        </div>
        <div class="flex flex-col gap-1 items-start justify-center w-full">
          <p class="text-sm font-semibold">{{ collection.name }}</p>
          <p class="text-GREY text-xs">{{ collection.amount }} NFT</p>
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-4 mt-5 items-start w-full">
      <p class="text-sm font-semibold">All NFT</p>
      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 w-full">
        <nft-card @click="router.push({ name: 'NftDetailPage' })"  v-for="nft in tempNftData" :nft-data="nft">
          <div class="gap-2 flex flex-col items-start">
            <p class="font-semibold text-sm">{{ nft.name }}</p>
            <div class="flex flex-row gap-2 justify-center items-center">
              <img src="@/assets/icons/token-2.svg" class="h-4 object-contain" />
              <p class="text-xs">{{ nft.price }}</p>
              <div class="rounded-full h-1 w-1 bg-WHITE"></div>
              <p class="text-xs">Stock {{ nft.stock }}</p>
            </div>
          </div>
        </nft-card>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import InheriteNftCard from '../InheriteNftCard.vue'
import NftCard from '../NftCard.vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const sliderTempData = ref([
  {
    name: 'Factura by Ahmet',
    type: 'SSR',
    price: '100',
    stock: '100'
  },
  {
    name: 'Aloha by Oğuz',
    type: 'R',
    price: '300',
    stock: '210'
  },
  {
    name: 'Vice Captain',
    type: 'SR',
    price: '150',
    stock: '50'
  }
])

const tempNftData = ref([
  {
    name: 'Factura by Ahmet',
    type: 'SSR',
    price: '100',
    stock: '100'
  },
  {
    name: 'Aloha by Oğuz',
    type: 'R',
    price: '300',
    stock: '210'
  },
  {
    name: 'Vice Captain',
    type: 'SR',
    price: '150',
    stock: '50'
  }
])

const collectionTempdata = ref([
  {
    name: 'puma Collection',
    amount: '25'
  },
  {
    name: 'Aloha Collection',
    amount: '18'
  },
  {
    name: 'Rize Collection',
    amount: '10'
  }
])
</script>

<style>
.slider-container {
  margin-left: -1rem; /* Use negative margin to offset parent padding */
  margin-right: -1rem; /* Adjust this value to counter the padding from the parent */
  overflow-x: auto; /* Enable horizontal scrolling */
  white-space: nowrap; /* Prevent wrapping of the content */
  scroll-snap-type: x mandatory; /* Optional: Smooth scrolling effect */
}

.flex-row {
  scroll-snap-align: start;
}
</style>
